import React, { ReactElement } from "react";
import { noticeError } from "../../services/monitoring";

interface ReportedErrorBoundaryProps {
  errorContent?: ReactElement;
  onError?: () => void;
}

export default class ReportedErrorBoundary extends React.Component<
  ReportedErrorBoundaryProps
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(e) {
    noticeError(e);
    this.props.onError?.();
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorContent || null;
    }

    return this.props.children;
  }
}
